<app-toast></app-toast>
<app-confirm-dialog></app-confirm-dialog>
<app-policy-consent></app-policy-consent>
<ng-container *ngIf="sidebarVisible">
  <app-header></app-header>
  <app-chatbot></app-chatbot>
</ng-container>
<div class="app-container" [class.with-header]="sidebarVisible">
  <app-sidebar *ngIf="sidebarVisible" [class.collapsed]="!expanded"></app-sidebar>
  <div class="main-content"
       [class.with-sidebar]="sidebarVisible"
       [class.sidebar-collapsed]="!expanded && sidebarVisible"
       [class.full-page]="!sidebarVisible">
    <router-outlet></router-outlet>
  </div>
</div>
